import FormGroup from "@mui/material/FormGroup";
import { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ActionButton from "./actionButton";
//import Button from "@mui/material/Button";
import { TextField } from "@mui/material";
import Container from "@mui/material/Container";
import EventContext from "../store/event-context";
import ColorSelection from "./colorSelection";

const ParticipantSelect = ({ itemsFound, isLoading, queryParticipants, teamFromList }) => {

  const eventctx = useContext(EventContext);
  const haveColor = eventctx.event.colors.length > 1;
  let localTeamName = teamFromList();
  const [color, setColor] = useState(eventctx.event.colors[0]);
  const [capnr, setCapnr] = useState("");
  const [zipcode, setZipCode] = useState("");
  const [housenumber, setHouseNumber] = useState("");
  const [teamName, setTeamName] = useState("");
  const [searching, setSearching] = useState(false);
  const [teamTyping, setTeamTyping] = useState(false);

  console.log("Render ParticipantSelect - teamName: ", teamName, "from service: ", localTeamName);
  
  // TODO Add a little validation as we do not want to fully trust users
  const searchByCapnr = () => {
    // TODO Fix URL encoding
    console.log("Looking for CAPNR: " + capnr);
    const query = "?capnr=" + encodeURI(color ? `${color}:${capnr}` : capnr);

    setSearching(true);
    setTeamTyping(false);
    queryParticipants(query);
  };

  // TODO Add a little validation as we do not want to fully trust users
  const searchByZipCode = () => {
    // TODO Fix URL encoding
    console.log("Looking for ZIPCODE: " + zipcode);
    console.log("and " + housenumber);
    let query = "?zipcode=" + encodeURI(zipcode);
    if (housenumber) {
      query = query + "housenumber=" + encodeURI(housenumber);
    }
    setSearching(true);
    setTeamTyping(false);
    queryParticipants(query);
  };

  // TODO Add a little validation as we do not want to fully trust users
  const searchByTeamName = () => {
    console.log("Looking for teamEvent: " + teamName + "-" + eventctx.event.eventid);
    //const query = "?teamEvent=" + encodeURI(teamName + "-" + eventctx.event.eventid);
    const query = "?teamName=" + encodeURI(teamName);
    setSearching(true);
    setTeamTyping(false);
    queryParticipants(query);
  };

  //const inputTeamName = (newTeam) => {
  //  setTeamName(newTeam);
  //  localTeamName = newTeam;
  //}

  useEffect(() => {
    if (searching && !isLoading) {
      setCapnr("");
      setZipCode("");
      setHouseNumber("");
      setTeamName("");
      setTeamTyping(false);
    }
  }, [isLoading, searching]);

  useEffect(() => {
    if (teamName === "" && localTeamName !== "" && !teamTyping) {
      setTeamName(localTeamName);
      localTeamName = "";
    }
  },[isLoading, searching, teamName, teamTyping]);

  return (
    <Box id="Registration">
      <Grid container direction="row" id="RegistrationTopInput" justifyContent="space-between" alignItems="center">
        <Grid item xs={7}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              searchByCapnr();
            }}
          >
            <FormGroup id="FormGroupCapnr">
              <Container id="ParticipantSelectionCapnr" disableGutters sx={{ pl: '6px'}}>
                {haveColor && <ColorSelection color={color} setColor={setColor} fieldWidth='120'/>}
                <TextField
                  required
                  id="capnrTextField"
                  type="number"
                  inputProps={{ keyboardtype: 'numeric' }}
                  value={capnr}
                  onChange={(e) => {
                    e.preventDefault();
                    setCapnr(e.target.value);
                  }}
                  label={haveColor? 'Capnr' : 'Capnummer'}
                  sx={{ mr: 1, width: haveColor? '122px': '250px' , backgroundColor: 'common.white'}}
                />
                <ActionButton
                  type="submit"
                  color="secondary"
                  id="searchCapnrButton"
                  sx={{ mt: '3px', width: '180px' }}
                >
                  Zoek Capnr
                </ActionButton>
              </Container>
            </FormGroup>
          </form>
        </Grid>
        <Grid item xs={5} container justifyContent="flex-end" sx={{ paddingRight:'8px'}} >
        <form
            onSubmit={(e) => {
              e.preventDefault();
              searchByTeamName();
            }}
          >
            <FormGroup id="FormGroupTeamName">
              <Container id="ParticipantSelectionTeam" disableGutters sx={{ pl: '6px'}}>
                <TextField
                  id="teamNameTextField"
                  value={teamName}
                  disabled
                  onChange={(e) => {
                    e.preventDefault();
                    setTeamTyping(true);
                    setTeamName(e.target.value);
                  }}
                  label="Team"
                  // sx={{ mr: 1, width: '250px' , backgroundColor: 'common.white'}}
                  sx={{ mr: 1, width: '250px'}}
                />
                <ActionButton
                  type="submit"
                  color="primary"
                  id="searchTeamButton"
                  sx={{ mt: '3px', width: '180px' }}
                >
                  Hele team
                </ActionButton>
              </Container>
            </FormGroup>
          </form>
        </Grid>
      </Grid>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          searchByZipCode();
        }}
      >
        <FormGroup id="FormGroupPostcode" sx={{ mt: 1}}>
          <Container id="ParticipantSelectionPostcode" disableGutters sx={{ pl: '6px'}}>
            <TextField
              required
              id="zipcodeTextField"
              value={zipcode}
              onChange={(e) => {
                e.preventDefault();
                setZipCode(e.target.value);
              }}
              label="Postcode"
              sx={{ mr: 1, width: '120px', backgroundColor: 'common.white'}}
            />
            <TextField
              id="housenumberTextField"
              value={housenumber}
              onChange={(e) => {
                e.preventDefault();
                setHouseNumber(e.target.value);
              }}
              label="Huisnr (optioneel)"
              sx={{ mr: 1, width: '122px', backgroundColor: 'common.white' }}
            />
            <ActionButton 
              type="submit" 
              color="primary" 
              id="searchZipcodeButton"
              sx={{ mt: '3px', width: '180px' }}>
              Zoek Postcode
            </ActionButton>
          </Container>
        </FormGroup>
      </form>
    </Box>
  );
};

export default ParticipantSelect;
